import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { DAILY_STATE_PERMISSION_CODES } from 'permissions/constants/dailyStatePermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { DAILY_STATE_PERMISSION_CODES };

const usePermissionsDailyState = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.DAILY_STATE),
      canViewSection: hasPermission(DAILY_STATE_PERMISSION_CODES.VIEW_SECTION),
      canGoToCause: hasPermission(DAILY_STATE_PERMISSION_CODES.GO_TO_CAUSE),
      canManage: hasPermission(DAILY_STATE_PERMISSION_CODES.MANAGE),
      canDownloadExcel: hasPermission(
        DAILY_STATE_PERMISSION_CODES.DOWNLOAD_EXCEL
      ),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsDailyState;
